import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=58af1e72&scoped=true&"
import script from "./Assistant.vue?vue&type=script&lang=js&"
export * from "./Assistant.vue?vue&type=script&lang=js&"
import style0 from "./Assistant.vue?vue&type=style&index=0&id=58af1e72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af1e72",
  null
  
)

export default component.exports